import {
  type GetCommunityGroupsErrorResponseDtoStatus,
  type GetCommunityGroupsSuccessResponseDtoStatus,
} from '@ccm-innovation/member-center-bff-sdk-axios';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type GetCommunityGroupListResponseStatus =
  | GetCommunityGroupsErrorResponseDtoStatus
  | GetCommunityGroupsSuccessResponseDtoStatus;

export type GetCommunityGroupListState = {
  pending: boolean;
  status: GetCommunityGroupListResponseStatus | null;
};

const initialState: GetCommunityGroupListState = {
  pending: false,
  status: null,
};

export const getCommunityGroupListSlice = createSlice({
  initialState,
  name: 'getCommunityGroupList',
  reducers: {
    getCommunityGroupListFailed: (
      state,
      action: PayloadAction<GetCommunityGroupListResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
    getCommunityGroupListRequested: () => {
      /* handled by saga */
    },
    getCommunityGroupListReset: () => {
      return initialState;
    },
    getCommunityGroupListStarted: (state) => {
      state.pending = true;
    },
    getCommunityGroupListSucceeded: (
      state,
      action: PayloadAction<GetCommunityGroupListResponseStatus>,
    ) => {
      state.pending = false;
      state.status = action.payload;
    },
  },
});
